import api from '../services/api';

// Hardware Assets
export const getAssets = async (params = {}) => {
  try {
    const response = await api.get('/assets', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching assets:', error);
    throw error;
  }
};

export const getAsset = async (id) => {
  try {
    const response = await api.get(`/assets/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching asset:', error);
    throw error;
  }
};

export const createAsset = async (assetData) => {
  try {
    const response = await api.post('/assets/save_hardware', assetData);
    return response.data.data;
  } catch (error) {
    console.error('Error creating asset:', error);
    throw error;
  }
};

export const updateAsset = async (assetData) => {
  try {
    const response = await api.put('/assets/update_hardware', assetData);
    return response.data.data;
  } catch (error) {
    console.error('Error updating asset:', error);
    throw error;
  }
};

export const deleteAsset = async (assetData) => {
  try {
    const response = await api.delete('/assets', { data: assetData });
    return response.data.data;
  } catch (error) {
    console.error('Error deleting asset:', error);
    throw error;
  }
};

export const restoreAsset = async (id) => {
  try {
    const response = await api.post(`/assets/${id}/restore`);
    return response.data.data;
  } catch (error) {
    console.error('Error restoring asset:', error);
    throw error;
  }
};

export const getAddHardwareFormData = async () => {
  try {
    const response = await api.get('/assets/add_hardware');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching hardware form data:', error);
    throw error;
  }
};

export const getEditHardwareData = async (id) => {
  try {
    const response = await api.get(`/assets/edit_hardware/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching hardware edit data:', error);
    throw error;
  }
};

// Software Assets
export const getSoftwareAssets = async (params = {}) => {
  try {
    const response = await api.get('/assets/software', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching software assets:', error);
    throw error;
  }
};

export const getSoftwareAsset = async (id) => {
  try {
    const response = await api.get(`/assets/view_software/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching software asset:', error);
    throw error;
  }
};

export const createSoftwareAsset = async (assetData) => {
  try {
    const response = await api.post('/assets/save_software', assetData);
    return response.data.data;
  } catch (error) {
    console.error('Error creating software asset:', error);
    throw error;
  }
};

export const updateSoftwareAsset = async (assetData) => {
  try {
    const response = await api.put('/assets/update_software', assetData);
    return response.data.data;
  } catch (error) {
    console.error('Error updating software asset:', error);
    throw error;
  }
};

export const getAddSoftwareFormData = async () => {
  try {
    const response = await api.get('/assets/add_software');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching software form data:', error);
    throw error;
  }
};

export const getEditSoftwareData = async (id) => {
  try {
    const response = await api.get(`/assets/edit_software/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching software edit data:', error);
    throw error;
  }
};

// System Assets
export const getSystemAssets = async (params = {}) => {
  try {
    const response = await api.get('/assets/systems', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching system assets:', error);
    throw error;
  }
};

export const getSystemAsset = async (id) => {
  try {
    const response = await api.get(`/assets/view_system/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching system asset:', error);
    throw error;
  }
};

export const createSystemAsset = async (assetData) => {
  try {
    const response = await api.post('/assets/save_system', assetData);
    return response.data.data;
  } catch (error) {
    console.error('Error creating system asset:', error);
    throw error;
  }
};

export const updateSystemAsset = async (assetData) => {
  try {
    const response = await api.put('/assets/update_software', assetData); // Systems use software update endpoint
    return response.data.data;
  } catch (error) {
    console.error('Error updating system asset:', error);
    throw error;
  }
};

export const getAddSystemFormData = async () => {
  try {
    const response = await api.get('/assets/add_system');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching system form data:', error);
    throw error;
  }
};

export const getEditSystemData = async (id) => {
  try {
    const response = await api.get(`/assets/edit_system/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching system edit data:', error);
    throw error;
  }
};

export const getViewSystemData = async (id) => {
  try {
    const response = await api.get(`/assets/view_system/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching system view data:', error);
    throw error;
  }
};

// Asset Management
export const getPurchaseHistory = async (params = {}) => {
  try {
    const response = await api.get('/assets/purchase_history', { params });
    return response.data.data;
  } catch (error) {
    console.error('Error fetching purchase history:', error);
    throw error;
  }
};

export const getOnSiteAssets = async () => {
  try {
    // Request all assets by setting a large limit to avoid pagination issues
    const response = await api.get('/assets/on_site?limit=1000');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching on-site assets:', error);
    throw error;
  }
};

export const getDisposedAssets = async () => {
  try {
    const response = await api.get('/assets/bin');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching disposed assets:', error);
    throw error;
  }
};

export const allocateAsset = async (allocationData) => {
  try {
    const response = await api.post(`/assets/${allocationData.asset_id}/allocate`, allocationData);
    return response.data.data;
  } catch (error) {
    console.error('Error allocating asset:', error);
    throw error;
  }
};

export const updateSiteAssets = async (siteData) => {
  try {
    const response = await api.put('/assets/sites', siteData);
    return response.data.data;
  } catch (error) {
    console.error('Error updating site assets:', error);
    throw error;
  }
};

export const getSiteAssets = async (siteId) => {
  try {
    const response = await api.get(`/assets/site_assets/${siteId}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching site assets:', error);
    throw error;
  }
};



// Asset Import/Export
export const importAssets = async (fileData) => {
  try {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const response = await api.post('/assets/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data.data;
  } catch (error) {
    console.error('Error importing assets:', error);
    throw error;
  }
};

export const exportAssets = async () => {
  try {
    const response = await api.get('/assets/export', {
      responseType: 'blob'
    });
    return response.data;
  } catch (error) {
    console.error('Error exporting assets:', error);
    throw error;
  }
};

// Asset Settings
export const getAssetSettings = async () => {
  try {
    const response = await api.get('/assets/settings');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching asset settings:', error);
    throw error;
  }
};

export const updateAssetSettings = async (settingsData) => {
  try {
    const response = await api.put('/assets/settings', settingsData);
    return response.data.data;
  } catch (error) {
    console.error('Error updating asset settings:', error);
    throw error;
  }
};

// Asset Declaration
export const getDeclarationData = async () => {
  try {
    const response = await api.get('/assets/declaration');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching declaration data:', error);
    throw error;
  }
};

export const getPendingDeclarations = async () => {
  try {
    const response = await api.get('/assets/pending_declarations');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching pending declarations:', error);
    throw error;
  }
};

export const declareAsset = async (declarationData) => {
  try {
    const response = await api.post('/assets/declare', declarationData);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error declaring asset:', error);
    throw error;
  }
};

// Send declaration notification email to a user after allocation
export const sendDeclarationEmail = async ({ ticket_id, user_id, asset_ids }) => {
  try {
    const response = await api.post('/assets/send_declaration_email', {
      ticket_id,
      user_id,
      asset_ids
    });
    return response.data;
  } catch (error) {
    console.error('Error sending declaration email:', error);
    throw error;
  }
};

export const getAssetDetails = async (id) => {
  try {
    const response = await api.get(`/assets/details/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching asset details:', error);
    throw error;
  }
};

export const getAssetHistory = async (id) => {
  try {
    const response = await api.get(`/assets/history/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching asset history:', error);
    throw error;
  }
};

// Get pending HOD approvals
export const getPendingHodApprovals = async () => {
  try {
    const response = await api.get('/assets/pending-hod-approvals');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching pending HOD approvals:', error);
    throw error;
  }
};

// Get HOD approval history (completed approvals)
export const getHodApprovalHistory = async (year = null) => {
  try {
    const url = year ? `/assets/hod-approval-history?year=${year}` : '/assets/hod-approval-history';
    const response = await api.get(url);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching HOD approval history:', error);
    throw error;
  }
};

// Approve or reject asset declaration
export const approveAssetDeclaration = async (data) => {
  try {
    const response = await api.post('/assets/approve-declaration', data);
    return response.data;
  } catch (error) {
    console.error('Error approving/rejecting declaration:', error);
    throw error;
  }
};

// Bulk approve or reject asset declarations
export const bulkApproveAssetDeclarations = async (data) => {
  try {
    const response = await api.post('/assets/bulk-approve-declarations', data);
    return response.data;
  } catch (error) {
    console.error('Error bulk approving/rejecting declarations:', error);
    throw error;
  }
};

// ==================== ANNUAL DECLARATION FUNCTIONS ====================

// Get pending annual declarations for current user (assets that need this year's declaration)
export const getPendingAnnualDeclarations = async () => {
  try {
    const response = await api.get('/assets/annual-declarations/pending');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching pending annual declarations:', error);
    throw error;
  }
};

// Submit annual asset declaration
export const submitAnnualDeclaration = async (data) => {
  try {
    const response = await api.post('/assets/annual-declarations/declare', data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error submitting annual declaration:', error);
    throw error;
  }
};

// Get declaration history for current user
export const getDeclarationHistory = async (year = null) => {
  try {
    const url = year 
      ? `/assets/annual-declarations/history?year=${year}`
      : '/assets/annual-declarations/history';
    const response = await api.get(url);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching declaration history:', error);
    throw error;
  }
};

// Get pending annual HOD approvals
export const getPendingAnnualHodApprovals = async () => {
  try {
    const response = await api.get('/assets/annual-declarations/hod-pending');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching pending annual HOD approvals:', error);
    throw error;
  }
};

// Approve or reject annual declaration
export const approveAnnualDeclaration = async (data) => {
  try {
    const response = await api.post('/assets/annual-declarations/approve', data);
    return response.data;
  } catch (error) {
    console.error('Error approving/rejecting annual declaration:', error);
    throw error;
  }
};

// Get declaration statistics
export const getDeclarationStats = async (year = null) => {
  try {
    const url = year 
      ? `/assets/annual-declarations/stats?year=${year}`
      : '/assets/annual-declarations/stats';
    const response = await api.get(url);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching declaration stats:', error);
    throw error;
  }
};
